/**
 * @fileoverview Container handle all object in entry.
 */

'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _tool = require("@entrylabs/tool");
var _GEHelper = require("../graphicEngine/GEHelper");
var _DataTable = _interopRequireDefault(require("./DataTable"));
var _legacyVideo = require("@entrylabs/legacy-video");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Class for a container.
 * This have view for objects.
 * @constructor
 */
Entry.Container = /*#__PURE__*/function () {
  function Container() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, Container);
    (0, _defineProperty2["default"])(this, "_rightClick", function (e) {
      e.stopPropagation();
      var touchEvent = Entry.Utils.convertMouseEvent(e);
      var options = [{
        text: Lang.Blocks.Paste_blocks,
        enable: !Entry.engine.isState('run') && !!_this.copiedObject,
        callback: function callback() {
          if (_this.copiedObject) {
            _this.addCloneObject(_this.copiedObject);
          } else {
            Entry.toast.alert(Lang.Workspace.add_object_alert, Lang.Workspace.object_not_found_for_paste);
          }
        }
      }];
      Entry.ContextMenu.show(options, 'workspace-contextmenu', {
        x: touchEvent.clientX,
        y: touchEvent.clientY
      });
    });
    /**
     * Array for entry objects
     * @type {Array.<Entry.EntryObject>}
     */
    this.objects_ = [];

    /**
     * Dictionary for caching images
     * @type {Dictionary.<createjs.Image}
     */
    this.cachedPicture = {};
    this.selectedObject = null;

    /**
     * variable for canvas input
     * @type {String}
     */
    this.inputValue = {};
    this.sttValue = {};
    /**
     * object model store copied object by context menu
     * @type {object model}
     */
    this.copiedObject = null;
    this.isObjectDragging = false;
    /**
     * Array for storing current scene objects
     * @type {Array.<object model>}
     */
    this.currentObjects_ = null;
    this._extensionObjects = [];
    Entry.addEventListener('workspaceChangeMode', function () {
      var ws = Entry.getMainWS();
      if (ws && ws.getMode() === Entry.Workspace.MODE_VIMBOARD) {
        _this.objects_.forEach(function (_ref) {
          var script = _ref.script;
          script && script.destroyView();
        });
      }
    });
    Entry.addEventListener('run', this.disableSort.bind(this));
    Entry.addEventListener('stop', this.enableSort.bind(this));
  }

  /**
   * Control bar view generator.
   * @param {!Element} containerView containerView from Entry.
   */
  return (0, _createClass2["default"])(Container, [{
    key: "generateView",
    value: function generateView(containerView) {
      var _this2 = this;
      this._view = containerView;
      this._view.addClass('entryContainer');
      this._view.addClass('entryContainerWorkspace');
      this._view.setAttribute('id', 'entryContainerWorkspaceId');
      var addButton = Entry.createElement('div').addClass('entryAddObjectWorkspace').bindOnClick(function () {
        Entry.dispatchEvent('openSpriteManager');
      });
      addButton.textContent = Lang.Workspace.add_object;
      var ulWrapper = Entry.createElement('div');
      this._view.appendChild(ulWrapper);

      // const scroll = new Simplebar(ulWrapper, { autoHide: false });
      var scrollWrapper = ulWrapper;
      var baseClass = 'entryContainerListWorkspaceWrapper';
      if (Entry.isForLecture) {
        baseClass += ' lecture';
      }
      scrollWrapper.addClass(baseClass);
      Entry.Utils.disableContextmenu(scrollWrapper);
      var longPressEvent = function longPressEvent(e) {
        var longPressTimer = null;
        var doc = $(document);
        longPressTimer = setTimeout(function () {
          if (longPressTimer) {
            longPressTimer = null;
            _this2._rightClick(e);
          }
        }, 1000);
        var event = Entry.Utils.convertMouseEvent(e);
        var mouseDownCoordinate = {
          x: event.clientX,
          y: event.clientY
        };

        // 움직임 포착된 경우 타이머 종료
        doc.bind('mousemove.container touchmove.container', function (e) {
          var event = Entry.Utils.convertMouseEvent(e);
          var moveThreshold = 5;
          if (!mouseDownCoordinate) {
            return;
          }
          var diff = Math.sqrt(Math.pow(event.pageX - mouseDownCoordinate.x, 2) + Math.pow(event.pageY - mouseDownCoordinate.y, 2));
          if (diff > moveThreshold && longPressTimer) {
            clearTimeout(longPressTimer);
            longPressTimer = null;
          }
        });

        // 터치가 끝난 경우 타이머 종료
        doc.bind('mouseup.container touchend.container', function () {
          doc.unbind('.container');
          if (longPressTimer) {
            clearTimeout(longPressTimer);
            longPressTimer = null;
          }
        });
      };
      /*
       * 오른쪽 버튼 클릭 시 컨텍스트메뉴 발생
       */
      scrollWrapper.addEventListener('mousedown', function (e) {
        if (Entry.Utils.isRightButton(e)) {
          e.stopPropagation();
          _this2._rightClick(e);
        }
        if (Entry.isMobile()) {
          e.stopPropagation();
          longPressEvent(e);
        }
      });

      /*
       * 터치 디바이스의 롱클릭 대응. touch 1초간 유지시 컨텍스트메뉴 발생.
       * 현재위치에서 일정 범위 이상 벗어난 경우취소
       */
      scrollWrapper.addEventListener('touchstart', function (e) {
        if (e.eventFromEntryObject) {
          return;
        }
        longPressEvent(e);
      });
      var extensionListView = Entry.createElement('ul');
      scrollWrapper.appendChild(extensionListView);
      this._extensionListView = Entry.Dom(extensionListView, {
        "class": 'entryContainerExtensions'
      });
      var listView = Entry.createElement('ul').addClass('entryContainerListWorkspace');
      scrollWrapper.appendChild(listView);
      this.listView_ = listView;
      this.enableSort();
    }
  }, {
    key: "enableSort",
    value: function enableSort() {
      var _this3 = this;
      if (this.sortableListViewWidget) {
        this.sortableListViewWidget.setData({
          disabled: false
        });
      } else {
        var draggableOption = {};
        if (Entry.isMobile()) {
          draggableOption.lockAxis = 'y';
          draggableOption.distance = 50;
        }
        this.sortableListViewWidget = new _tool.Draggable({
          data: _objectSpread(_objectSpread({}, draggableOption), {}, {
            canSortable: true,
            sortableTarget: ['entryObjectThumbnailWorkspace'],
            items: this._getSortableObjectList(),
            itemShadowStyle: {
              position: 'absolute',
              height: '100%',
              width: '100%',
              backgroundColor: '#8aa3b2',
              border: 'solid 1px #728997'
            },
            onDragActionChange: function onDragActionChange(isDragging, key) {
              if (!Entry.objectEditable) {
                return;
              }
              Entry.ContextMenu.hide();
              if (isDragging) {
                _this3.selectedObject.setObjectFold(isDragging, true);
              } else {
                _this3.selectedObject.resetObjectFold();
              }
              Entry.playground.setBackpackPointEvent(isDragging);
              _this3.dragObjectKey = key;
              _this3.isObjectDragging = isDragging;
            },
            onChangeList: function onChangeList(newIndex, oldIndex) {
              if (!Entry.objectEditable) {
                return;
              }
              if (newIndex !== oldIndex) {
                Entry["do"]('objectReorder', newIndex, oldIndex);
              }
            }
          }),
          container: this.listView_
        });
      }
    }
  }, {
    key: "updateSortableObjectList",
    value: function updateSortableObjectList(objects) {
      this.sortableListViewWidget.setData({
        items: this._getSortableObjectList(objects)
      });
    }
  }, {
    key: "_getSortableObjectList",
    value: function _getSortableObjectList(objects) {
      var targetObjects = objects || this.currentObjects_ || [];
      return targetObjects.map(function (value) {
        var id = value.id,
          view_ = value.view_,
          thumbUrl = value.thumbUrl;
        return {
          key: id,
          item: view_,
          image: thumbUrl
        };
      });
    }

    /**
     * disable sort.
     */
  }, {
    key: "disableSort",
    value: function disableSort() {
      var view = this.listView_;
      if (!view) {
        return;
      }
      this.sortableListViewWidget.setData({
        disabled: true
      });
    }

    /**
     * update list view to sort item.
     */
  }, {
    key: "updateListView",
    value: function updateListView() {
      var view = this.listView_;
      if (!view) {
        return;
      }
      var objs = this.getCurrentObjects().slice();
      var ret = objs.filter(function (_ref2) {
        var index = _ref2.index;
        return index !== undefined;
      });
      if (ret.length === objs.length) {
        objs = objs.sort(function (a, b) {
          return a.index - b.index;
        });
      }
      objs.forEach(function (obj) {
        !obj.view_ && obj.generateView();
      });
      Entry.stage.sortZorder();
      this.updateSortableObjectList(objs);
      return true;
    }
  }, {
    key: "setObjects",
    value: function setObjects(objectModels) {
      var _this4 = this;
      objectModels.forEach(function (model) {
        if (model) {
          var object = new Entry.EntryObject(model);
          _this4.objects_.push(object);
        }
      });
      this.updateObjectsOrder();
      this.updateListView();
      Entry.variableContainer.updateViews();
      var type = Entry.type;
      if (type === 'workspace' || type === 'phone' || type === 'playground') {
        var target = this.getCurrentObjects()[0];
        target && this.selectObject(target.id);
      }
    }

    /**
     * get Pictures element
     * @param {!String} pictureId
     */
  }, {
    key: "getPictureElement",
    value: function getPictureElement(pictureId, objectId) {
      var object = this.getObject(objectId);
      var picture = object.getPicture(pictureId);
      if (picture) {
        return picture.view;
      } else {
        throw new Error('No picture found');
      }
    }
    /**
     * Set Pictures
     * @param {!Object picture} picture
     */
  }, {
    key: "setPicture",
    value: function setPicture(picture) {
      var pictures = this.getObject(picture.objectId).pictures;
      var index = _.findIndex(pictures, function (_ref3) {
        var id = _ref3.id;
        return id === picture.id;
      });
      if (!~index) {
        throw new Error('No picture found');
      }
      pictures[index] = (0, _extends2["default"])(_.pick(picture, ['dimension', 'id', 'filename', 'fileurl', 'thumbUrl', 'name', 'imageType']), {
        view: pictures[index].view
      });
    }

    /**
     * Set Pictures
     * @param {!String} pictureId
     */
  }, {
    key: "selectPicture",
    value: function selectPicture(pictureId, objectId) {
      var object = this.getObject(objectId);
      var picture_ = object.getPicture(pictureId);
      if (picture_) {
        object.selectedPicture = picture_;
        object.entity.setImage(picture_);
        object.updateThumbnailView();
        this.sortableListViewWidget.setData({
          items: this._getSortableObjectList()
        });
        return object.id;
      }
      throw new Error('No picture found');
    }
  }, {
    key: "selectSound",
    value: function selectSound(soundId, objectId) {
      var object = this.getObject(objectId);
      var sound = object.getSound(soundId);
      if (sound) {
        object.selectedSound = sound;
        return object.id;
      }
      throw new Error('No sound found');
    }

    /**
     * Add object
     * @param {!object model} objectModel
     * @param {?number} index exist when user add object
     * @return {Entry.EntryObject}
     */
  }, {
    key: "addObject",
    value: function addObject(objectModel) {
      var _Entry;
      var target;
      if ('name' in objectModel.sprite) {
        target = objectModel.sprite;
      } else {
        target = objectModel;
        if (!target.name) {
          target.name = 'untitled';
        }
      }
      target.name = Entry.getOrderedName(target.name, this.objects_);
      objectModel.id = objectModel.id || Entry.generateHash();
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      return (_Entry = Entry)["do"].apply(_Entry, ['addObject', objectModel].concat(rest));
    }
  }, {
    key: "addObjectFunc",
    value: function addObjectFunc(objectModel, index, isNotRender) {
      delete objectModel.scene;
      var object = new Entry.EntryObject(objectModel);
      object.scene = Entry.scene.selectedScene;
      var isBackground = objectModel.sprite.category || {};
      isBackground = isBackground.main === 'background';
      if (typeof index === 'number') {
        if (isBackground) {
          object.setLock(true);
          this.objects_.push(object);
        } else {
          this.objects_.splice(index, 0, object);
        }
      } else if (isBackground) {
        this.objects_.push(object);
      } else {
        this.objects_.unshift(object);
      }
      if (!isNotRender) {
        object.generateView();
        this.setCurrentObjects();
        this.selectObject(object.id);
        this.updateObjectsOrder();
        this.updateListView();
        Entry.variableContainer.updateViews();
        Entry.variableContainer.updateList();
      }
    }
  }, {
    key: "renderObject",
    value: function renderObject(object) {
      object.generateView();
      this.setCurrentObjects();
      this.selectObject(object.id);
      Entry.variableContainer.updateViews();
    }
  }, {
    key: "addExtension",
    value: function addExtension(obj) {
      this._extensionObjects.push(obj);
      if (this._extensionListView) {
        this._extensionListView.append(obj.renderView());
      }
      return obj;
    }
  }, {
    key: "removeExtension",
    value: function removeExtension(obj) {
      if (!obj) {
        return;
      }
      var extensions = this._extensionObjects;
      var index = extensions.indexOf(obj);
      if (~index) {
        extensions.splice(index, 1);
      }
      obj.destroy && obj.destroy();
    }

    /**
     * Add Clone object
     * @param {!Entry.EntryObject} object
     */
  }, {
    key: "addCloneObject",
    value: function addCloneObject(object, scene, isNotRender) {
      var json = object.toJSON(true);
      json.script = change('sounds', object, json);
      json.script = change('pictures', object, json);
      Entry.variableContainer.addCloneLocalVariables({
        objectId: object.id,
        newObjectId: json.id,
        json: json
      });
      json.scene = scene || Entry.scene.selectedScene;
      this.addObject(json, null, isNotRender);
      return this.getObject(json.id);
      function change(keyName, object, jsonData) {
        var target = jsonData.sprite[keyName];
        var script = jsonData.script;
        (object[keyName] || []).forEach(function (value, index) {
          script = script.replace(new RegExp(value.id, 'g'), target[index].id);
        });
        return script;
      }
    }
  }, {
    key: "removeObject",
    value: function removeObject(id, isPass) {
      var objects = this.objects_;
      var object = this.getObject(id);
      var index = objects.indexOf(object);
      object.destroy();
      objects.splice(index, 1);
      Entry.variableContainer.removeLocalVariables(object.id);
      Entry.engine.hideProjectTimer();
      if (isPass === true) {
        return;
      }
      this.setCurrentObjects();
      Entry.stage.sortZorder();
      var _this$getCurrentObjec = this.getCurrentObjects(),
        _this$getCurrentObjec2 = (0, _slicedToArray2["default"])(_this$getCurrentObjec, 1),
        first = _this$getCurrentObjec2[0];
      if (first) {
        this.selectObject(first.id);
      } else {
        Entry.stage.selectObject(null);
        Entry.playground.flushPlayground();
      }
      this.updateListView();
      Entry.playground.reloadPlayground();
      _GEHelper.GEHelper.resManager.imageRemoved('container::removeObject');
    }

    /**
     * Select object
     * @param {string} objectId
     */
  }, {
    key: "selectObject",
    value: function selectObject(objectId, changeScene) {
      if (!objectId) {
        return;
      }
      var object = this.getObject(objectId);
      var workspace = Entry.getMainWS();
      var isSelected = object && object.isSelected();
      if (changeScene && object) {
        Entry.scene.selectScene(object.scene);
      }
      var className = 'selectedObject';
      this.mapObjectOnScene(function (o) {
        !o.view_ && _.result(o, 'generateView');
        var selected = o === object;
        var view = o.view_;
        if (view) {
          if (selected) {
            view.addClass(className);
          } else {
            view.removeClass(className);
            o.setObjectFold(false);
          }
        }
        o.isSelected_ = selected;
      });
      if (object) {
        if (workspace && workspace.vimBoard && Entry.isTextMode) {
          var sObject = workspace.vimBoard._currentObject;
          var parser = workspace.vimBoard._parser;
          if (sObject && !this.getObject(sObject.id)) {} else if (parser && parser._onError) {
            if (sObject && object.id != sObject.id) {
              if (!Entry.scene.isSceneCloning) {
                try {
                  workspace._syncTextCode();
                } catch (e) {}
                if (parser && !parser._onError) {
                  this.selectObject(object.id, true);
                  return;
                } else {
                  this.selectObject(sObject.id, true);
                  return;
                }
              } else {
                this.selectObject(sObject.id);
                return;
              }
            }
          } else {
            if (sObject && object.id != sObject.id) {
              if (!Entry.scene.isSceneCloning) {
                try {
                  workspace._syncTextCode();
                } catch (e) {}
                if (parser && parser._onError) {
                  this.selectObject(sObject.id, true);
                  return;
                }
              } else {
                this.selectObject(sObject.id);
                return;
              }
            }
          }
        }
      } else {
        workspace && workspace.vimBoard && workspace.vimBoard.clearText();
      }
      if (Entry.playground) {
        object ? Entry.playground.injectObject(object) : Entry.playground.injectEmptyObject();
      }
      if (Entry.type !== 'minimize' && Entry.engine.isState('stop')) {
        Entry.stage.selectObject(object);
      }
      this.selectedObject = object;
      !isSelected && object && object.updateCoordinateView();
    }

    /**
     * Get all objects
     */
  }, {
    key: "getAllObjects",
    value: function getAllObjects() {
      return this.objects_;
    }

    /**
     * Object Getter
     * @param {string} objectId
     * @return {Entry.EntryObject}
     */
  }, {
    key: "getObject",
    value: function getObject(objectId) {
      var playground = Entry.playground;
      if (!objectId && playground && playground.object) {
        objectId = playground.object.id;
      } else if (objectId instanceof Entry.EntryObject) {
        return objectId;
      }
      return _.find(this.objects_, {
        id: objectId
      });
    }

    /**
     * Entity Getter
     * @param {string} objectId
     * @return {Entry.EntityObject}
     */
  }, {
    key: "getEntity",
    value: function getEntity(objectId) {
      var object = this.getObject(objectId);
      if (!object) {
        return Entry.toast.alert(Lang.Msgs.runtime_error, Lang.Workspace.object_not_found, true);
      }
      return object.entity;
    }

    /**
     * get variable on canvas
     * @return {Entry.Variable}
     */
  }, {
    key: "getVariable",
    value: function getVariable(variableId) {
      for (var i = 0; i < this.variables_.length; i++) {
        var variable = this.variables_[i];
        if (variable.getId() == variableId) {
          return variable;
        }
        if (variable.getName() == variableId) {
          return variable;
        }
      }
    }

    /**
     * Move object in objects_
     * this method is for sortable
     * @param {number!} start
     * @param {number!} end
     * @param {boolean?} isCallFromState
     * @return {Entry.State}
     */
  }, {
    key: "moveElement",
    value: function moveElement(end, start) {
      var objs = this.getCurrentObjects();
      var startIndex = this.getAllObjects().indexOf(objs[start]);
      var endIndex = this.getAllObjects().indexOf(objs[end]);
      this.objects_.splice(endIndex, 0, this.objects_.splice(startIndex, 1)[0]);
      this.setCurrentObjects();
      this.updateListView();
      Entry.requestUpdate = true;
    }

    /**
     * generate list for dropdown dynamic
     * obj param for renderview.changeCode
     * @param {string} menuName
     * @param {string} obj
     */
  }, {
    key: "getDropdownList",
    value: (function () {
      var _getDropdownList = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(menuName, obj) {
        var result, object, _object, _object2, tables, _object3, i, inputList, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              result = [];
              _t = menuName;
              _context.next = _t === 'sprites' ? 1 : _t === 'allSprites' ? 2 : _t === 'spritesWithMouse' ? 3 : _t === 'spritesWithSelf' ? 4 : _t === 'textBoxWithSelf' ? 5 : _t === 'collision' ? 6 : _t === 'pictures' ? 7 : _t === 'messages' ? 9 : _t === 'variables' ? 10 : _t === 'lists' ? 12 : _t === 'tables' ? 14 : _t === 'scenes' ? 15 : _t === 'sounds' ? 16 : _t === 'clone' ? 18 : _t === 'objectSequence' ? 19 : _t === 'fonts' ? 20 : _t === 'connectedCameras' ? 21 : _t === 'blockCount' ? 23 : 24;
              break;
            case 1:
              result = this.getCurrentObjects().map(function (_ref4) {
                var name = _ref4.name,
                  id = _ref4.id;
                return [name, id];
              });
              return _context.abrupt("continue", 24);
            case 2:
              result = this.getAllObjects().map(function (_ref5) {
                var name = _ref5.name,
                  id = _ref5.id,
                  _ref5$scene = _ref5.scene,
                  scene = _ref5$scene === void 0 ? {} : _ref5$scene;
                var sceneName = scene.name;
                return ["".concat(sceneName, " - ").concat(name), id];
              });
              return _context.abrupt("continue", 24);
            case 3:
              result = this.getCurrentObjects().map(function (_ref6) {
                var name = _ref6.name,
                  id = _ref6.id;
                return [name, id];
              });
              result.push([Lang.Blocks.mouse_pointer, 'mouse']);
              return _context.abrupt("continue", 24);
            case 4:
              result = this.getCurrentObjects().map(function (_ref7) {
                var name = _ref7.name,
                  id = _ref7.id;
                return [name, id];
              });
              result.push([Lang.Blocks.self, 'self']);
              return _context.abrupt("continue", 24);
            case 5:
              result = [].concat((0, _toConsumableArray2["default"])(this.getCurrentObjects().reduce(function (acc, _ref8) {
                var objectType = _ref8.objectType,
                  name = _ref8.name,
                  id = _ref8.id;
                if (objectType === 'textBox') {
                  acc.push([name, id]);
                }
                return acc;
              }, result)), [[Lang.Blocks.self, 'self']]);
              return _context.abrupt("continue", 24);
            case 6:
              result = [[Lang.Blocks.mouse_pointer, 'mouse']].concat((0, _toConsumableArray2["default"])(this.getCurrentObjects().map(function (_ref9) {
                var name = _ref9.name,
                  id = _ref9.id;
                return [name, id];
              })), [[Lang.Blocks.wall, 'wall'], [Lang.Blocks.wall_up, 'wall_up'], [Lang.Blocks.wall_down, 'wall_down'], [Lang.Blocks.wall_right, 'wall_right'], [Lang.Blocks.wall_left, 'wall_left']]);
              return _context.abrupt("continue", 24);
            case 7:
              object = Entry.playground.object || obj;
              if (object) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("continue", 24);
            case 8:
              result = (object.pictures || []).map(function (_ref0) {
                var name = _ref0.name,
                  id = _ref0.id;
                return [name, id];
              });
              return _context.abrupt("continue", 24);
            case 9:
              result = Entry.variableContainer.messages_.map(function (_ref1) {
                var name = _ref1.name,
                  id = _ref1.id;
                return [name, id];
              });
              return _context.abrupt("continue", 24);
            case 10:
              _object = Entry.playground.object || obj;
              if (_object) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("continue", 24);
            case 11:
              Entry.variableContainer.variables_.forEach(function (variable) {
                if (variable.object_ && _object && (variable.object_ != _object.id || Entry.Func.isEdit)) {
                  return;
                }
                result.push([variable.getName(), variable.getId()]);
              });
              if (!result || result.length === 0) {
                // result.push([Lang.Blocks.VARIABLE_variable, 'null']);
                result = [];
              }
              return _context.abrupt("continue", 24);
            case 12:
              _object2 = Entry.playground.object || obj;
              if (_object2) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("continue", 24);
            case 13:
              Entry.variableContainer.lists_.forEach(function (list) {
                if (list.object_ && _object2 && (list.object_ != _object2.id || Entry.Func.isEdit)) {
                  return;
                }
                result.push([list.getName(), list.getId()]);
              });
              if (!result || result.length === 0) {
                // result.push([Lang.Blocks.VARIABLE_list, 'null']);
                result = [];
              }
              return _context.abrupt("continue", 24);
            case 14:
              tables = _DataTable["default"].tables;
              if (tables) {
                result = tables.map(function (table) {
                  return [table.name, table.id];
                });
              }
              return _context.abrupt("continue", 24);
            case 15:
              result = Entry.scene.getScenes().map(function (_ref10) {
                var name = _ref10.name,
                  id = _ref10.id;
                return [name, id];
              });
              return _context.abrupt("continue", 24);
            case 16:
              _object3 = Entry.playground.object || obj;
              if (_object3) {
                _context.next = 17;
                break;
              }
              return _context.abrupt("continue", 24);
            case 17:
              result = (_object3.sounds || []).map(function (_ref11) {
                var name = _ref11.name,
                  id = _ref11.id;
                return [name, id];
              });
              return _context.abrupt("continue", 24);
            case 18:
              result = [[Lang.Blocks.oneself, 'self']].concat((0, _toConsumableArray2["default"])(this.getCurrentObjects().map(function (_ref12) {
                var name = _ref12.name,
                  id = _ref12.id;
                return [name, id];
              })));
              return _context.abrupt("continue", 24);
            case 19:
              for (i = 0; i < this.getCurrentObjects().length; i++) {
                result.push([(i + 1).toString(), i.toString()]);
              }
              return _context.abrupt("continue", 24);
            case 20:
              result = EntryStatic.fonts.filter(function (x) {
                return x.visible;
              }).map(function (font) {
                return [font.name, font.family];
              });
              return _context.abrupt("continue", 24);
            case 21:
              _context.next = 22;
              return (0, _legacyVideo.getInputList)();
            case 22:
              inputList = _context.sent;
              result = [].concat(inputList.filter(function (input) {
                return input.kind === 'videoinput';
              }).map(function (item, index) {
                return [item.label || "Unspecified Device-".concat(index + 1), index];
              }));
              return _context.abrupt("continue", 24);
            case 23:
              result = [[Lang.Blocks.this_project, 'all'], [Lang.Blocks.this_object, 'self']].concat((0, _toConsumableArray2["default"])(this.getCurrentObjects().map(function (_ref13) {
                var name = _ref13.name,
                  id = _ref13.id;
                return [name, "object-".concat(id)];
              })), (0, _toConsumableArray2["default"])(Entry.scene.getScenes().map(function (_ref14) {
                var name = _ref14.name,
                  id = _ref14.id;
                return [name, "scene-".concat(id)];
              })));
            case 24:
              if (!result.length) {
                result = [[Lang.Blocks.no_target, 'null']];
              }
              return _context.abrupt("return", result);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDropdownList(_x, _x2) {
        return _getDropdownList.apply(this, arguments);
      }
      return getDropdownList;
    }()
    /**
     * Initialize entities to state before run
     */
    )
  }, {
    key: "clearRunningState",
    value: function clearRunningState() {
      this.mapObject(function (object) {
        object.clearExecutor();
      });
    }
  }, {
    key: "clearRunningStateOnScene",
    value: function clearRunningStateOnScene() {
      this.mapObjectOnScene(function (object) {
        if (object instanceof Entry.TargetChecker) {
          return;
        }
        object.clearExecutor();
      });
    }

    /**
     * Apply map function to objects. But this not replace object with returned one.
     * So giving map function don't have to return object.
     * And this support another arguments.
     * @param {!function} mapFunction
     * @param {} param
     */
  }, {
    key: "mapObject",
    value: function mapObject(mapFunction, param) {
      return [].concat((0, _toConsumableArray2["default"])(this._extensionObjects), (0, _toConsumableArray2["default"])(this.objects_)).map(function (object) {
        return mapFunction(object, param);
      });
    }
  }, {
    key: "mapObjectOnScene",
    value: function mapObjectOnScene(mapFunction, param) {
      return [].concat((0, _toConsumableArray2["default"])(this._extensionObjects), (0, _toConsumableArray2["default"])(this.getCurrentObjects())).map(function (object) {
        return mapFunction(object, param);
      });
    }

    /**
     * Apply map function to objects. But this not replace object with returned one.
     * So giving map function don't have to return object.
     * And this support another arguments.
     * @param {!function} mapFunction
     * @param {} param
     */
  }, {
    key: "mapEntity",
    value: function mapEntity(mapFunction, param) {
      return this.objects_.map(function (_ref15) {
        var entity = _ref15.entity;
        return mapFunction(entity, param);
      });
    }
  }, {
    key: "mapEntityOnScene",
    value: function mapEntityOnScene(mapFunction, param) {
      return this.getCurrentObjects().map(function (_ref16) {
        var entity = _ref16.entity;
        return mapFunction(entity, param);
      });
    }

    /**
     * Apply map function to objects. But this not replace object with returned one.
     * So giving map function don't have to return object.
     * And this support another arguments.
     * This also apply to cloned entities.
     * @param {!function} mapFunction
     * @param {} param
     */
  }, {
    key: "mapEntityIncludeClone",
    value: function mapEntityIncludeClone(mapFunction, param) {
      var objects = this.objects_;
      var length = objects.length;
      var output = [];
      for (var i = 0; i < length; i++) {
        var object = objects[i];
        var lenx = object.clonedEntities.length;
        output.push(mapFunction(object.entity, param));
        for (var j = 0; j < lenx; j++) {
          var entity = object.clonedEntities[j];
          if (entity && !entity.isStamp) {
            output.push(mapFunction(entity, param));
          }
        }
      }
      return output;
    }
  }, {
    key: "mapEntityIncludeCloneOnScene",
    value: function mapEntityIncludeCloneOnScene(mapFunction, param) {
      var objects = this.getCurrentObjects();
      var length = objects.length;
      var output = [];
      for (var i = 0; i < this._extensionObjects.length; i++) {
        var object = this._extensionObjects[i];
        output.push(mapFunction(object.entity, param));
      }
      for (var _i = 0; _i < length; _i++) {
        var _object4 = objects[_i];
        output.push(mapFunction(_object4.entity, param));
        _object4.getClonedEntities().forEach(function (entity) {
          output.push(mapFunction(entity, param));
        });
      }
      return output;
    }

    /**
     * @deprecated 새로운 리소스 관리자 생겨서 이제 사용안함
     * Get cached picture
     * @param {!string} pictureId
     * @return {?createjs.Image}
     */
  }, {
    key: "getCachedPicture",
    value: function getCachedPicture(pictureId) {
      Entry.assert(typeof pictureId === 'string', 'pictureId must be string');
      return this.cachedPicture[pictureId];
    }

    /**
     * @deprecated 새로운 리소스 관리자 생겨서 이제 사용안함
     * cache picture
     * @param {!picture object} pictureModel
     */
  }, {
    key: "cachePicture",
    value: function cachePicture(pictureId, image) {
      this.cachedPicture[pictureId] = image;
    }

    /**
     * @deprecated 새로운 리소스 관리자 생겨서 이제 사용안함
     * @param entity
     * @param pictures
     * @param isClone
     */
  }, {
    key: "unCachePictures",
    value: function unCachePictures(entity, pictures, isClone) {
      var _this5 = this;
      if (!entity || !pictures) {
        return;
      }
      var entityId;
      if (pictures.constructor !== Array) {
        pictures = [pictures];
      }
      if (entity.constructor === Entry.EntityObject) {
        entityId = entity.id;
      } else {
        entityId = entity;
      }
      pictures.forEach(function (_ref17) {
        var id = _ref17.id;
        delete _this5.cachedPicture[id + (isClone ? '' : entityId)];
      });
    }

    /**
     * convert this object's data to JSON.
     * @return {JSON}
     */
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.objects_.map(function (object) {
        return object.toJSON();
      });
    }

    /**
     * take snapshot of current objects sequence
     */
  }, {
    key: "takeSequenceSnapshot",
    value: function takeSequenceSnapshot() {
      var length = this.objects_.length;
      var objects = this.objects_;
      for (var i = 0; i < length; i++) {
        objects[i].index = i;
      }
    }

    /**
     * load snapshot of original objects sequence
     */
  }, {
    key: "loadSequenceSnapshot",
    value: function loadSequenceSnapshot() {
      var length = this.objects_.length;
      var arr = new Array(length);
      for (var i = 0; i < length; i++) {
        var object = this.objects_[i];
        var _index = object.index !== undefined ? object.index : i;
        arr[_index] = object;
        delete object.index;
      }
      this.objects_ = arr;
      this.setCurrentObjects();
      Entry.stage.sortZorder();
      this.updateListView();
    }

    /**
     * return canvas inputValue
     * @return {String}
     */
  }, {
    key: "getInputValue",
    value: function getInputValue() {
      return this.inputValue.getValue();
    }
  }, {
    key: "getSttValue",
    value: function getSttValue() {
      return this.sttValue.getValue();
    }

    /**
     * set canvas inputValue
     * @param {String} inputValue from canvas
     */
  }, {
    key: "setInputValue",
    value: function setInputValue(inputValue) {
      if (this.inputValue.complete) {
        return;
      }
      if (!inputValue) {
        this.inputValue.setValue(0);
      } else {
        this.inputValue.setValue(inputValue);
      }
      Entry.stage.hideInputField();
      Entry.dispatchEvent('answerSubmitted');
      if (Entry.console) {
        Entry.console.stopInput(inputValue);
      }
      this.inputValue.complete = true;
    }
  }, {
    key: "setSttValue",
    value: function setSttValue(inputValue) {
      if (this.sttValue.complete) {
        return;
      }
      if (!inputValue) {
        this.sttValue.setValue('');
      } else {
        this.sttValue.setValue(inputValue);
      }
      Entry.dispatchEvent('sttSubmitted');
      this.sttValue.complete = true;
    }
  }, {
    key: "enableSttValue",
    value: function enableSttValue() {
      this.sttValue.complete = false;
    }
  }, {
    key: "resetSceneDuringRun",
    value: function resetSceneDuringRun() {
      if (!Entry.engine.isState('run')) {
        return;
      }
      this.mapEntityOnScene(function (entity) {
        entity.reset();
      });
      this.clearRunningStateOnScene();
      Entry.stage.hideInputField();
    }
  }, {
    key: "setCopiedObject",
    value: function setCopiedObject(object) {
      this.copiedObject = object;
    }
  }, {
    key: "updateObjectsOrder",
    value: function updateObjectsOrder() {
      var _this6 = this;
      this.objects_ = Entry.scene.getScenes().reduce(function (objs, scene) {
        return [].concat((0, _toConsumableArray2["default"])(objs), (0, _toConsumableArray2["default"])(_this6.getSceneObjects(scene)));
      }, []);
    }

    /**
     *  get objects list belonged to specific scene
     *  @param {scene model} scene
     *  @return {Array<object model>}
     */
  }, {
    key: "getSceneObjects",
    value: function getSceneObjects(scene) {
      scene = scene || Entry.scene.selectedScene;
      if (!scene) {
        return [];
      }
      var sceneId = scene.id;
      return this.getAllObjects().filter(function (_ref18) {
        var id = _ref18.scene.id;
        return id === sceneId;
      });
    }

    /**
     *  set objects list belonged to specific scene
     */
  }, {
    key: "setCurrentObjects",
    value: function setCurrentObjects() {
      this.currentObjects_ = this.getSceneObjects();
      if (this.currentObjects_.length) {
        Entry.playground.hidePictureCurtain();
      } else {
        Entry.playground.showPictureCurtain();
      }
    }

    /**
     *  get objects list belonged to current scene
     */
  }, {
    key: "getCurrentObjects",
    value: function getCurrentObjects() {
      if (_.isEmpty(this.currentObjects_)) {
        this.setCurrentObjects();
      }
      return this.currentObjects_ || [];
    }

    /**
     *  get project jsons in art_view for saving especially for art_viewcontroller
     *  @param {!resource project} project
     *  @return {entry project} project
     */
  }, {
    key: "getProjectWithJSON",
    value: function getProjectWithJSON(project) {
      project.objects = this.toJSON();
      project.variables = Entry.variableContainer.getVariableJSON();
      project.messages = Entry.variableContainer.getMessageJSON();
      project.scenes = Entry.scene.toJSON();
      return project;
    }
  }, {
    key: "blurAllInputs",
    value: function blurAllInputs() {
      this.getSceneObjects().map(function (_ref19) {
        var view_ = _ref19.view_;
        $(view_).find('input').blur();
      });
    }
  }, {
    key: "showProjectAnswer",
    value: function showProjectAnswer() {
      var answer = this.inputValue;
      if (!answer) {
        return;
      }
      answer.setVisible(true);
    }
  }, {
    key: "showSttAnswer",
    value: function showSttAnswer() {
      var answer = this.sttValue;
      if (!answer) {
        return;
      }
      answer.setVisible(true);
    }
  }, {
    key: "hideProjectAnswer",
    value: function hideProjectAnswer(removeBlock, notIncludeSelf) {
      var answer = this.inputValue;
      if (!answer || !answer.isVisible() || Entry.engine.isState('run')) {
        return;
      }
      var objects = this.getAllObjects();
      var answerTypes = ['ask_and_wait', 'get_canvas_input_value', 'set_visible_answer'];
      for (var i = 0, len = objects.length; i < len; i++) {
        var code = objects[i].script;
        for (var j = 0; j < answerTypes.length; j++) {
          var blocks = code.getBlockList(false, answerTypes[j]);
          if (notIncludeSelf) {
            var index = blocks.indexOf(removeBlock);
            if (~index) {
              blocks.splice(index, 1);
            }
          }
          if (blocks.length) {
            return;
          }
        }
      }

      //answer related blocks not found
      //hide canvas answer view
      answer.setVisible(false);
    }
  }, {
    key: "hideSttAnswer",
    value: function hideSttAnswer(removeBlock, notIncludeSelf) {
      var answer = this.sttValue;
      if (!answer || !answer.isVisible() || Entry.engine.isState('run')) {
        return;
      }
      var objects = this.getAllObjects();
      var answerTypes = ['ask_and_wait', 'get_canvas_input_value', 'set_visible_answer'];
      for (var i = 0, len = objects.length; i < len; i++) {
        var code = objects[i].script;
        for (var j = 0; j < answerTypes.length; j++) {
          var blocks = code.getBlockList(false, answerTypes[j]);
          if (notIncludeSelf) {
            var index = blocks.indexOf(removeBlock);
            if (~index) {
              blocks.splice(index, 1);
            }
          }
          if (blocks.length) {
            return;
          }
        }
      }

      //answer related blocks not found
      //hide canvas answer view
      answer.setVisible(false);
    }
  }, {
    key: "getView",
    value: function getView() {
      return this._view;
    }

    // dummy
  }, {
    key: "resize",
    value: function resize() {
      return;
    }
  }, {
    key: "removeFuncBlocks",
    value: function removeFuncBlocks(functionType) {
      this.objects_.forEach(function (_ref20) {
        var script = _ref20.script;
        script.removeBlocksByType(functionType);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      [].concat((0, _toConsumableArray2["default"])(this.objects_), (0, _toConsumableArray2["default"])(this._extensionObjects)).forEach(function (o) {
        return o.destroy();
      });
      this.objects_ = [];
      // INFO : clear 시도할때 _extensionObjects 초기화
      this._extensionObjects = [];
      // TODO: clear 때 this._extensionListView 도 비워 줘야 하는지 확인 필요.
      Entry.playground.clear();
    }
  }, {
    key: "selectNeighborObject",
    value: function selectNeighborObject(option) {
      var objects = this.getCurrentObjects();
      if (!objects || objects.length === 0) {
        return;
      }
      var currentIndex = objects.indexOf(Entry.playground.object);
      var maxLen = objects.length;
      switch (option) {
        case 'prev':
          if (--currentIndex < 0) {
            currentIndex = objects.length - 1;
          }
          break;
        case 'next':
          currentIndex = ++currentIndex % maxLen;
          break;
      }
      var object = objects[currentIndex];
      if (!object) {
        return;
      }
      this.selectObject(object.id);
    }
  }, {
    key: "getObjectIndex",
    value: function getObjectIndex(objectId) {
      return this.objects_.indexOf(this.getObject(objectId));
    }
  }, {
    key: "getDom",
    value: function getDom(query) {
      if (query.length >= 1) {
        switch (query.shift()) {
          case 'objectIndex':
            return this.objects_[query.shift()].getDom(query);
          case 'objectId':
            return this.getObject(query.shift()).getDom(query);
        }
      } else {}
    }
  }, {
    key: "isSceneObjectsExist",
    value: function isSceneObjectsExist() {
      return !_.isEmpty(this.getSceneObjects());
    }
  }, {
    key: "adjustClonedValues",
    value: function adjustClonedValues(oldIds, newIds) {
      if (!(oldIds && newIds)) {
        return;
      }
      var that = this;
      newIds.forEach(function (newId) {
        that.getObject(newId).script.getBlockList().forEach(function (b) {
          if (!b || !b.params) {
            return;
          }
          var changed = false;
          var ret = b.params.map(function (p) {
            if (typeof p !== 'string') {
              return p;
            }
            var index = oldIds.indexOf(p);
            if (index < 0) {
              return p;
            }
            changed = true;
            return newIds[index];
          });
          changed && b.set({
            params: ret
          });
        });
      });
    }
  }, {
    key: "getBlockList",
    value: function getBlockList() {
      return _.flatten(this.objects_.map(function (_ref21) {
        var script = _ref21.script;
        return script.getBlockList();
      }));
    }
  }, {
    key: "scrollToObject",
    value: function scrollToObject(ObjectId) {
      var _this$getObject = this.getObject(ObjectId),
        view_ = _this$getObject.view_;
      view_ && view_.scrollIntoView();
      document.body.scrollIntoView();
    }
  }, {
    key: "setSound",
    value: function setSound(sound) {
      var sounds = this.getObject(sound.objectId).sounds;
      var index = _.findIndex(sounds, function (_ref22) {
        var id = _ref22.id;
        return id === sound.id;
      });
      if (!~index) {
        throw new Error('No sound found');
      }
      var path = sound.fileurl || "".concat(Entry.defaultPath, "/uploads/").concat(sound.filename.substring(0, 2), "/").concat(sound.filename.substring(2, 4), "/").concat(Entry.soundPath).concat(sound.filename).concat(sound.ext || '.mp3');
      sounds[index] = (0, _extends2["default"])(_.pick(sound, ['duration', 'ext', 'fileurl', 'filename', 'id', 'label', 'name', 'path']), {
        view: sounds[index].view,
        path: path
      });
      return sounds[index];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // 우선 interface 만 정의함.
    }
  }]);
}();